import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { patientQKeys } from "@hooks/queries/patient/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  allergyId: string;
  patientId: string;
}

export const useDeleteAllergy = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ allergyId }: MutationProps) => {
      return api.delete(`patient/allergy/${allergyId}`);
    },

    onSuccess: (_, variables) => {
      showSuccessNotification({
        title: "success",
        message: "delete-allergy-success",
      });
      queryClient.invalidateQueries({
        queryKey: patientQKeys.allergy(variables.patientId),
      });
    },

    onError: (res: any) => {
      console.error("[From Delete Allergy]", res);

      handleErrors(res, "mutation");
    },
  });
};
